import apiService from 'services/apiService';
import { getQueryString } from 'modules/MonitorAlpha/shared/utils';

const baseUrl = `${window._env_.MONITOR_API_DOMAIN}`;

const getFacilities = (entityId) => {
  const url = `${baseUrl}/v1/entities/${entityId}/facilities`;
  return apiService.get(url);
};

const getCounterFacilities = (entityId, queryParams) => {
  const queryString = getQueryString(queryParams);
  const url = `${baseUrl}/v1/entities/${entityId}/introducer/clients/facilities/count${queryString}`;
  return apiService.get(url);
};

export { getFacilities, getCounterFacilities };
